import * as React from 'react';
import styled from 'styled-components';
import { darken, rem } from 'polished';
import { FlexColCenter, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';
import { IconImg, OutsideClick, TextP } from '../../..';
import { __ } from 'react-i18n';
import { Button } from '../General/Button';

interface Props {
  onButtonClick: any;
  onRequestClick: any;
  disabled?: boolean;
  avail_id?: number;
  hasDropdown?: boolean;
  product?: any;
  count: number;
  hasWatchdog?: boolean;
  hasFavourite?: boolean;
  canOrder?: boolean;
  hideCart?: boolean;
  hasUser?: boolean;
  cannotOrderButtonText?: string;
  isNew?: boolean;
  isWaiting?: boolean;
  showCompareIcon?: boolean;
  isCompare?: boolean;
  addToCompare: (id) => void;
}

function ButtonWithRequest({
  onButtonClick,
  onRequestClick,
  disabled,
  avail_id = 1,
  hasDropdown = false,
  product,
  count = 1,
  hasWatchdog = true,
  hasFavourite = true,
  canOrder,
  hideCart,
  hasUser,
  cannotOrderButtonText,
  isNew,
  isWaiting,
  showCompareIcon,
  isCompare,
  addToCompare
}: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [iscompareP, setIsCompareP] = React.useState(isCompare);

  const correctRotation = isOpen ? 180 : 0;

  const isAvailable = avail_id === 1;

  const toggleOpen = () => {
    resetState();
  };

  const resetState = () => {
    setIsOpen(!isOpen);
  };

  const handleRequestClick = e => {
    onRequestClick();
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  if (hideCart) {
    return null;
  }
  // if (process.env.NODE_ENV !== 'development') {
  //   if (canOrder && !hasUser) {
  //     return null;
  //   }
  // }

  return (
    <Wrapper>
      <MobileWrapper>
        <CartButton
          title={
            canOrder
              ? __('Pridať do košíka')
              : cannotOrderButtonText
              ? cannotOrderButtonText
              : __('Kde kúpiť')
          }
          // disabled={disabled}
          disabled={false}
          type="button"
          /* tslint:disable-next-line:jsx-no-lambda */
          onClick={() => {
            onButtonClick(product, count);
          }}
          avail_id={avail_id}
          hasDropdown={hasDropdown}
          canOrder={canOrder}
          isNew={isNew}
          isWaiting={isWaiting}
        >
          {canOrder ? (
            <>
              <SvgIcon
                title={
                  canOrder
                    ? __('Pridať do košíka')
                    : cannotOrderButtonText
                    ? cannotOrderButtonText
                    : __('Kde kúpiť')
                }
                icon={IconType.cart}
                fill={'#FFFFFF'}
                cursor={'pointer'}
                alt={
                  canOrder
                    ? __('Pridať do košíka')
                    : cannotOrderButtonText
                    ? cannotOrderButtonText
                    : __('Kde kúpiť')
                }
              />
            </>
          ) : cannotOrderButtonText ? (
            cannotOrderButtonText
          ) : (
            __('Kde kúpiť')
          )}
        </CartButton>
      </MobileWrapper>
      <DesktopWrapper>
        <CartButton
          title={
            canOrder
              ? __('Pridať do košíka')
              : cannotOrderButtonText
              ? cannotOrderButtonText
              : __('Kde kúpiť')
          }
          // disabled={disabled}
          disabled={false}
          type="button"
          /* tslint:disable-next-line:jsx-no-lambda */
          onClick={() => {
            onButtonClick(product, count);
          }}
          avail_id={avail_id}
          hasDropdown={hasDropdown}
          canOrder={canOrder}
          isNew={isNew}
          isWaiting={isWaiting}
        >
          {canOrder ? (
            <>
              <SvgIcon
                title={
                  canOrder
                    ? __('Pridať do košíka')
                    : cannotOrderButtonText
                    ? cannotOrderButtonText
                    : __('Kde kúpiť')
                }
                icon={IconType.cart}
                fill={'#FFFFFF'}
                cursor={'pointer'}
                alt={
                  canOrder
                    ? __('Pridať do košíka')
                    : cannotOrderButtonText
                    ? cannotOrderButtonText
                    : __('Kde kúpiť')
                }
              />
            </>
          ) : cannotOrderButtonText ? (
            cannotOrderButtonText
          ) : (
            __('Kde kúpiť')
          )}
        </CartButton>
      </DesktopWrapper>
      {hasDropdown && (
        <OutsideClick handleFunction={closeDropdown}>
          <DropdownArrow onClick={toggleOpen} avail_id={avail_id} canOrder={canOrder} isNew={isNew} isWaiting={isWaiting}>
            <IconImg
              cursor={'pointer'}
              rotate={correctRotation}
              src={'/assets/dsi/arrow-triangle.svg'}
              alt="Šípka"
              width={8}
              height={4}
            />
          </DropdownArrow>
          <DropdownWrapper isOpen={isOpen}>
            {showCompareIcon && (
              <DropdownRow type="button" onClick={() => {setIsCompareP(!iscompareP); addToCompare(product.product_id);}}>
                <StyledSvgIcon icon={IconType.compare} fill={iscompareP?'#000000':'#CCCCCC'} />
                <TextP>{__('Porovnať produkt')}</TextP>
              </DropdownRow>)}
            {hasFavourite && (
              <DropdownRow type="button" onClick={handleRequestClick}>
                <StyledSvgIcon icon={IconType.favourites} fill={'#CCCCCC'} />
                <TextP>{__('Do obľúbených')}</TextP>
              </DropdownRow>
            )}
            {hasWatchdog && (
              <DropdownRow type="button">
                <StyledSvgIcon icon={IconType.dog} fill={'#CCCCCC'} />
                <TextP>{__('Strážny pes')}</TextP>
              </DropdownRow>
            )}
          </DropdownWrapper>
        </OutsideClick>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  position: relative;
  justify-content: flex-end;
`;

const MobileWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.mediab.m580`
    display: block;
  `}
`;

const DesktopWrapper = styled.div`
  display: block;

  ${({ theme }) => theme.mediab.m580`
    display: none;
  `}
`;

const CartButton = styled(Button)<{
  avail_id: number;
  hasDropdown: boolean;
  canOrder?: boolean;
  isNew?: boolean;
  isWaiting?: boolean;
}>`
  background-color: ${({ theme, avail_id, canOrder, isNew, isWaiting }) =>
    isWaiting
      ? theme.colors.cartButtonExpecting
      : canOrder
      ? avail_id === 1
        ? theme.colors.stockCountAvailable
        : isNew
        ? theme.colors.cartButtonExpecting
        : theme.colors.stockCountSold
      : theme.colors.primary};
  box-shadow: 0px 1px 4px #00000014;
  border-radius: ${({ hasDropdown }) =>
    hasDropdown ? '4px 0 0 4px' : '4px 4px 4px 4px '};
  padding: ${rem(16)};
  height: ${rem(56)};

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.primary)};
    transition: background-color 0.2s ease;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
  }
`;

const DropdownArrow = styled(FlexColCenter)<{ 
  avail_id: number, 
  canOrder?: boolean;
  isNew?: boolean;
  isWaiting?: boolean; }>`
  min-width: ${rem(32)};
  padding: ${rem(22)} ${rem(8)};
  background-color: ${({ theme, avail_id, canOrder, isNew, isWaiting }) =>
    isWaiting
      ? theme.colors.cartButtonExpecting
      : canOrder
      ? avail_id === 1
        ? theme.colors.stockCountAvailable
        : isNew
        ? theme.colors.cartButtonExpecting
        : theme.colors.stockCountSold
      : theme.colors.primary};
  border-left: 1px solid white;
  border-radius: 0 ${rem(4)} ${rem(4)} 0;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.secondary)};
    transition: background-color 0.2s ease;
  }
  
  height: 100%;
`;

const DropdownWrapper = styled.div<{ isOpen: boolean }>`
  width: ${rem(240)};
  position: absolute;
  display: ${({ isOpen }) => (!isOpen ? 'none' : 'flex')};
  flex-direction: column;
  top: ${rem(48)};
  right: 0;
  box-shadow: 0px 1px 24px #00000014;
  border: 1px solid #cccccc;
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  border-radius: ${rem(4)};
  z-index: 10;
  text-align: left;
  padding: 0;
`;

const DropdownRow = styled(Button)`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  border-bottom: 1px solid #cccccc;
  &:last-child {
    border: 0;
  }
`;

const StyledSvgIcon = styled(SvgIcon)`
  margin-right: ${rem(16)};
`;

const ToCartText = styled.span`
  font-size: ${rem(14)};
  font-weight: 500;
  margin-left: ${rem(10)};
  display: flex;
  align-items: flex-end;
`;

export { ButtonWithRequest };
